import { CivilStatus } from '../../../core/enum/civil-status.enum';
import { QuoteApiResponse } from '../services/quote.service';

export interface BreakdownRow {
  label: string;
  amount: string;
}

export interface BreakdownSection {
  title: string;
  rows: BreakdownRow[];
}

export function buildBreakdown(
  civilStatus: string,
  withChildren: boolean | null,
  response: QuoteApiResponse,
): BreakdownSection[] {
  const sections: BreakdownSection[] = [];
  const familyRows: BreakdownRow[] = [];

  const coverage = response.familyShieldCoverage;

  // -------------------------------
  // Family Protection Section
  // -------------------------------

  if (civilStatus === CivilStatus.Married) {
    familyRows.push({
      label: 'Asawa',
      amount: coverage.spouse,
    });

    familyRows.push({
      label: 'Bawat Anak',
      amount: coverage.child,
    });
  }

  if (civilStatus !== CivilStatus.Married && withChildren === false) {
    familyRows.push({
      label: 'Bawat Magulang',
      amount: coverage.parent,
    });

    familyRows.push({
      label: 'Bawat Kapatid',
      amount: coverage.sibling,
    });
  }

  if (civilStatus !== CivilStatus.Married && withChildren === true) {
    familyRows.push({
      label: 'Bawat Anak',
      amount: coverage.child,
    });
  }

  if (familyRows.length > 0) {
    sections.push({
      title: 'Family Protection',
      rows: familyRows,
    });
  }

  sections.push({
    title: '** Scroll down to see full coverage details',
    rows: [],
  });

  return sections;
}
